import "react-dates/initialize"
import React, { useState } from "react"
import classnames from "classnames"
import { func, string, bool, shape } from "prop-types"
import moment from "moment"
import "moment/locale/pt-br"

import DateRangePicker from "react-dates/lib/components/DateRangePicker"
import Arrow from "./components/Arrow"
import Period from "./components/Period"
import ModernButton from "shared/components/Button/ModernButton"

import { handleWeekDays } from "./utils/handleWeekDays"
import { ICON_BEFORE_POSITION } from "react-dates/lib/constants.js"

import calendarIcon from "assets/svg/calendar-clean.svg"

import ThemeConsumer from "shared/components/ThemeConsumer"
import "react-dates/lib/css/_datepicker.css"
import "./react-dates.css"

import styles from "./styles.css"

moment.locale("pt-br")

const DateRange = ({
  period,
  startDate,
  endDate,
  onDatesChange,
  onConfirm = () => {},
  isOutsideRange,
  isDayBlocked,
  anchorDirection,
  label,
  theme,
  required = false
}) => {
  const [focusedInput, onFocusChange] = useState(null)

  const renderButtons = () => {
    return (
      <div
        className={classnames(
          "u-flex u-flexJustifyEnd",
          theme.p4,
          theme.borderContainer
        )}
      >
        <ModernButton
          type="button"
          shape="outline"
          size="medium_extra"
          buttonColor="deep_sea_green"
          text="Cancelar"
          textColor="deep_sea_green"
          textSize="small"
          withBorderRadius
          sizeRadius="small"
          onClick={() => {
            onDatesChange({ startDate, endDate })
            onFocusChange(null)
          }}
        />
        <ModernButton
          type="button"
          shape="full"
          size="medium_extra"
          buttonColor="deep_sea_green"
          text="Aplicar"
          textColor="white"
          textSize="small"
          classNames={theme.ml2}
          withBorderRadius
          sizeRadius="small"
          onClick={() => {
            onFocusChange(null)
            onConfirm({
              startDate,
              endDate
            })
          }}
        />
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <DateRangePicker
        showKeyboardShortcuts={false}
        weekDayFormat="ddd"
        keepOpenOnDateSelect
        startDate={startDate}
        startDateId="datePickerStart"
        endDateId="datePickerEnd"
        endDate={endDate}
        focusedInput={focusedInput}
        onFocusChange={(focus) => {
          onFocusChange(focus)
        }}
        onDatesChange={onDatesChange}
        startDatePlaceholderText="00/00/0000"
        endDatePlaceholderText="00/00/0000"
        required
        showDefaultInputIcon={false}
        customInputIcon={<img src={calendarIcon} alt="Ícone de calendário" />}
        navPrev={<Arrow />}
        navNext={<Arrow direction="right" />}
        readOnly
        regular
        calendarInfoPosition="bottom"
        renderCalendarInfo={renderButtons}
        inputIconPosition={ICON_BEFORE_POSITION}
        anchorDirection={anchorDirection}
        isOutsideRange={isOutsideRange || (() => {})}
        isDayBlocked={isDayBlocked}
        renderDayContents={handleWeekDays}
        noBorder
        keepFocusOnInput={true}
        onOutsideClick={() => {}}
      />

      {label && (
        <label className={classnames(styles.label, styles.labelFloat)}>
          {label}
          {required && <span style={{ color: "red" }}> *</span>}
        </label>
      )}

      <Period startDate={startDate} endDate={endDate} period={period} />
    </div>
  )
}

DateRange.propTypes = {
  period: string,
  startDate: string,
  endDate: string,
  onDatesChange: func,
  onFocusChange: func,
  onConfirm: func.isRequired,
  focusedInput: string,
  isOutsideRange: bool,
  anchorDirection: string,
  isDayBlocked: func,
  renderCalendarInfo: func,
  label: string,
  required: bool,
  theme: shape({
    p4: string,
    borderContainer: string
  })
}

DateRange.defaultProps = {
  focusedInput: null,
  isOutsideRange: false,
  onFocusChange: null
}

export default ThemeConsumer("UIReactDateRange")(DateRange)



// WEBPACK FOOTER //
// ./src/components/DateRangePicker/index.js